import { render, staticRenderFns } from "./CreateStockBatchDialog.vue?vue&type=template&id=2b55076a&"
import script from "./CreateStockBatchDialog.vue?vue&type=script&lang=js&"
export * from "./CreateStockBatchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports